module.exports = __webpack_public_path__ + "static/img/huaishuItem3.f772635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuItem3.png
// module id = UVeg
// module chunks = 0